/**
 * Fallback UI shown in place of a PDF viewer when the document
 * can't be displayed in the browser.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import './PdfFallback.css'

interface PdfFallbackProps {
  pdfDoc: string
}

export const PdfFallback = ({ pdfDoc }: PdfFallbackProps) => (
  <div className="pdf-fallback">
    <img
      className="pdf-fallback-icon"
      src="/icon/file-type-icon.svg"
      alt=""
    />
    <div className="pdf-fallback-content">
      <div className="pdf-fallback-title">Unable to display this PDF</div>
      <div className="pdf-fallback-message">
        The document couldn&apos;t be loaded in your browser. You can
        download it and open it locally instead.
      </div>
    </div>
    <a
      href={pdfDoc}
      download
      className="button py-2 px-4 button-dark text-center"
    >
      <div className="button-label button-large">Download PDF</div>
    </a>
  </div>
)
